import parse from 'html-react-parser';
import { FoxwayGradingFormQuestion } from '@/lib/types/foxway';
import { useStore } from '../hooks/useStore';
import { Label } from '@/lib/components/ui/label';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/lib/components/ui/accordion';
import useTranslation from '../hooks/useTranslation';
import { useRef } from 'react';

const GradingQuestion = ({
  question,
}: {
  question: FoxwayGradingFormQuestion;
}) => {
  const gradingAnswers = useStore((state) => state.gradingAnswers);
  const setGradingAnswer = useStore((state) => state.setGradingAnswer);
  const gradingAnswer = gradingAnswers?.[question.Id];
  const { gradingExplainQuestion } = useTranslation();
  const radioRefs = useRef<(HTMLButtonElement | null)[]>([]);

  return (
    <AccordionItem value={`question-${question.Id}`}>
      <fieldset key={`question-${question.Id}`} className="flex items-center">
        <div className="grow">
          <AccordionTrigger className="flex flex-col gap-0.5 py-3">
            <legend className="text-base">{question.Name}</legend>
            <p className="underline text-sm">{gradingExplainQuestion}</p>
          </AccordionTrigger>
        </div>
        <div className="shrink-0 flex align-center gap-4">
          {question.Answers?.map((answer) => (
            <div
              className="flex items-center gap-2"
              key={`${question.Id}-${answer.Id}`}
            >
              <span className="relative w-5 h-5">
                <input
                  type="radio"
                  value={`${answer.Id}`}
                  id={`${question.Id}-${answer.Id}`}
                  name={`${question.Id}`}
                  aria-describedby={question.Name}
                  checked={gradingAnswer === answer.Id}
                  onChange={() => setGradingAnswer(question.Id, answer.Id)}
                  className="peer appearance-none w-5 h-5 rounded-full border border-black transition-colors checked:border-samsungBlue"
                />
                <span
                  className={
                    'pointer-events-none absolute top-1/2 left-1/2 w-3 h-3 rounded-full bg-samsungBlue transition -translate-x-1/2 -translate-y-1/2 opacity-0 peer-checked:opacity-100'
                  }
                />
              </span>
              <Label
                htmlFor={`${question.Id}-${answer.Id}`}
                className="capitalize"
              >
                {answer.Name ?? ''}
              </Label>
            </div>
          ))}
        </div>
      </fieldset>
      <AccordionContent className="flex flex-col gap-4 text-balance">
        {question.InfoCards?.map((info) => info.Text ?? '')?.map(
          (info: string, index) => (
            <div
              key={`info-${index}`}
              className="text-base space-y-2 bg-secondaryBackground p-4 rounded-md"
            >
              {parse(info)}
            </div>
          ),
        )}
      </AccordionContent>
    </AccordionItem>
  );
};

export default GradingQuestion;
